import {css} from '@yandex-delivery/blocks/theme/css'

export const captionText = css`
  opacity: 0.5;
`
